import styled from 'styled-components';

const StyledGivzLogo = styled.div`
  path {
    fill: #37746b !important;
  }
`;

const GivzLogoGreen = () => {
  return (
    <StyledGivzLogo>
      <svg width="90" height="40" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.6 7.876c1.77-1.313 3.574-2.263 5.413-2.85 1.839-.587 3.964-.88 6.376-.88 2.412 0 5.179.448 8.302 1.346l-1.978 5.389c-2.22-.553-4.598-.83-7.13-.83-2.534 0-4.755.873-6.663 2.617-1.909 1.745-3.21 4.776-3.904 9.094-.243 1.554-.365 2.953-.365 4.197 0 5.25 2.17 7.875 6.507 7.875 1.076 0 2.22-.103 3.435-.31l1.041-6.426h-4.893l.885-5.44h11.712L23.735 37.72C19.71 39.24 15.711 40 11.737 40c-3.973 0-7.07-1.433-9.29-4.3C.814 33.591 0 30.621 0 26.787c0-1.486.19-3.49.573-6.01.381-2.522 1.214-4.984 2.498-7.384 1.284-2.4 2.793-4.24 4.528-5.518zm32.427 4.3-4.268 27.15h-7.287l4.216-26.528 7.34-.622zM34.927 1.4C36.001.466 37.13 0 38.308 0c1.18 0 2.082.371 2.707 1.114.625.743.937 1.546.937 2.41 0 1.45-.538 2.65-1.614 3.6-1.075.95-2.203 1.425-3.383 1.425-1.18 0-2.082-.38-2.707-1.14-.624-.76-.936-1.589-.936-2.487 0-1.45.537-2.625 1.613-3.523zm17.54 32.124 8.901-20.777h7.34l-12.545 26.58h-9.161l-3.956-26.58h7.34l2.081 20.777zm37.165-20.725v4.041L75.109 34.404h12.493l-.157 4.922H66.833l-.052-3.886 14.522-17.668h-10.67l.312-4.974h18.687z"
          fillRule="nonzero"
        />
      </svg>
    </StyledGivzLogo>
  );
};

export default GivzLogoGreen;
